module.exports = __webpack_public_path__ + "img/happytable_info2.fd28a15b.jpg";